import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { ViewModel } from '@smarttask-common/src/lib/models/View/Core/ViewModel';

export enum ViewActionTypes {
    ADD_VIEW = '[View] Create View',
    ADD_VIEWS = '[View] Add Views',
    UPSERT_VIEW = '[View] Upsert View',
    UPSERT_VIEWS = '[View] Upsert Views',
    UPDATE_VIEW = '[View] Update View',
    UPDATE_VIEWS = '[View] Update Views',
    DELETE_VIEW = '[View] Delete View',
    DELETE_VIEWS = '[View] Delete Views',
    DELETE_ALL_VIEWS = '[View] Delete All Views',
    DELETE_ALL = '[View] Delete All',

    UPDATE_SELECTED_ID = '[view] Update SelectedId',
}

export class UpdateSelectedViewId implements Action {
    readonly type = ViewActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_view_id: string) {}
}

export class AddOne implements Action {
    readonly type = ViewActionTypes.ADD_VIEW;
    constructor(public view: ViewModel) {}
}

export class AddMany implements Action {
    readonly type = ViewActionTypes.ADD_VIEWS;
    constructor(public views: Array<ViewModel>) {}
}

export class UpsertOne implements Action {
    readonly type = ViewActionTypes.UPSERT_VIEW;
    constructor(public view: ViewModel) {}
}

export class UpsertMany implements Action {
    readonly type = ViewActionTypes.UPSERT_VIEWS;
    constructor(public views: Array<ViewModel>) {}
}

export class UpdateOne implements Action {
    readonly type = ViewActionTypes.UPDATE_VIEW;
    constructor(public view: Update<ViewModel>) {}
}

export class UpdateMany implements Action {
    readonly type = ViewActionTypes.UPDATE_VIEWS;
    constructor(public views: Array<Update<ViewModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = ViewActionTypes.DELETE_VIEW;
    constructor(public id: string) {}
}

export class DeleteMany implements Action {
    readonly type = ViewActionTypes.DELETE_VIEWS;
    constructor(public ids: Array<string>) {}
}

export class DeleteAll implements Action {
    readonly type = ViewActionTypes.DELETE_ALL_VIEWS;
    constructor(public ids: Array<string>) {}
}

export class DeleteState implements Action {
    readonly type = ViewActionTypes.DELETE_ALL;
    constructor() {}
}

export type ViewActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedViewId;
